import React, { useState, useEffect } from 'react';
import AnalyticsStatCard from '../../components/AnalyticsStatCard';
import { CalendarBlank, Clock, Percent, UserGear } from '@phosphor-icons/react';
import COLORS from '../../util/constants/colors';
import { calculateReportTime } from './helpers';

// Total conversion counts patients who reached Scheduled or Completed, and Completed is a
// subset of it, so the remainder is the share still waiting on their visit.
const conversionBreakdown = (totalPercentage, completedPercentage) => {
  if (typeof totalPercentage !== 'number' || typeof completedPercentage !== 'number') return null;

  const scheduledPercentage = Math.max(Math.round((totalPercentage - completedPercentage) * 100) / 100, 0);
  // Typography styles every nested span as inline-flex, which drops the spaces between the
  // parts; a block wrapper keeps the sentence in normal inline flow.
  return (
    <span style={{ display: 'block' }}>
      <span style={{ color: COLORS.BLUE_PRIMARY_LITE, fontWeight: 600 }}>{`${scheduledPercentage}%`}</span>
      {' scheduled + '}
      <span style={{ color: COLORS.SUCCESS_HOVER_LITE, fontWeight: 600 }}>{`${completedPercentage}%`}</span>
      {' completed'}
    </span>
  );
};

const ReferralStats = ({ analyticsData, loading }) => {
  const [averageScheduledTime, setAverageScheduledTime] = useState(0);
  const [averageTimeToFirstStatusChange, setAverageTimeToFirstStatusChange] = useState(0);

  useEffect(() => {
    setAverageScheduledTime(calculateReportTime(analyticsData.average_scheduled_time));
    setAverageTimeToFirstStatusChange(calculateReportTime(analyticsData.average_time_to_first_status_change));
  }, [analyticsData]);

  return (
    <div className="analytics-stats">
      <AnalyticsStatCard
        label="Unique Referrals Received"
        value={analyticsData.unique_referrals}
        valueColor={COLORS.SUCCESS_HOVER_LITE}
        icon={<UserGear size={24} weight="bold" />}
        iconColor={COLORS.SUCCESS_SECONDARY_DARK}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Total Conversion"
        value={analyticsData.percentage_referrals_scheduled}
        valueColor={COLORS.BLUE_PRIMARY_LITE}
        unit="%"
        subtitle={conversionBreakdown(
          analyticsData.percentage_referrals_scheduled,
          analyticsData.percentage_referrals_completed,
        )}
        icon={<Percent size={24} weight="bold" />}
        iconColor={COLORS.BLUE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Avg Time to Schedule"
        value={averageScheduledTime}
        valueColor={COLORS.ORANGE_PRIMARY_LITE}
        icon={<CalendarBlank size={24} weight="bold" />}
        iconColor={COLORS.ATTENTION_SECONDARY_LITE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Avg Time to First Contact"
        value={averageTimeToFirstStatusChange}
        valueColor={COLORS.PURPLE_PRIMARY_LITE}
        icon={<Clock size={24} weight="bold" />}
        iconColor={COLORS.PURPLE_TERTIARY_LITE}
        loading={loading}
      />
    </div>
  );
};

export default ReferralStats;
